module.exports = __webpack_public_path__ + "static/intel-ai-logo-f2f32a83356bc34aa8aca21db7752650.png";